(function () {
  'use strict';

  var root = document.getElementById('Pdp-Experts-Section');
  if (!root) return;

  var prevBtn = root.querySelector('.Pdp-Experts-Chevron-Container.prev');
  var nextBtn = root.querySelector('.Pdp-Experts-Chevron-Container.next');
  var cards = root.querySelectorAll('.Pdp-Experts-Card');

  var currentIndex = 0;
  // maxVisible set via data attribute from Section Liquid; default 2
  var maxVisibleSetting = root.dataset.maxVisible ? parseInt(root.dataset.maxVisible, 10) : 2;
  var maxVisible = maxVisibleSetting;

  function removeDisableClass(element) {
    if (!element) return;
    if (element.classList.contains('disable')) {
      element.classList.remove('disable');
    }
  }

  function addDisableClass(element) {
    if (!element) return;
    if (!element.classList.contains('disable')) {
      element.classList.add('disable');
    }
  }

  function toggleDisableClass(index) {
    if (index === 0) {
      addDisableClass(prevBtn);
    } else {
      removeDisableClass(prevBtn);
    }
    if (index === cards.length - maxVisible) {
      addDisableClass(nextBtn);
    } else {
      removeDisableClass(nextBtn);
    }
  }

  function initializeDisplay() {
    cards.forEach(function (card) {
      card.style.display = 'none';
    });

    if (window.innerWidth >= 320 && window.innerWidth <= 767) {
      maxVisible = 1;
    } else if (window.innerWidth >= 1024) {
      maxVisible = maxVisibleSetting;
    } else {
      maxVisible = 2;
    }

    for (var i = 0; i < maxVisible && i < cards.length; i++) {
      cards[i].style.display = 'flex';
    }

    var arrowWrapper = root.querySelector('.Pdp-Experts-Arrow-Wrapper');
    if (arrowWrapper) {
      arrowWrapper.style.display = cards.length <= maxVisible ? 'none' : 'flex';
    }
    toggleDisableClass(currentIndex);
  }

  initializeDisplay();

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) {
        cards[currentIndex + maxVisible - 1].style.display = 'none';
        currentIndex--;
        cards[currentIndex].style.display = 'flex';
        toggleDisableClass(currentIndex);
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      if (currentIndex < cards.length - maxVisible) {
        cards[currentIndex].style.display = 'none';
        currentIndex++;
        cards[currentIndex + maxVisible - 1].style.display = 'flex';
        toggleDisableClass(currentIndex);
      }
    });
  }

  function updateResponsiveExperts() {
    var screenWidth = window.innerWidth;

    cards.forEach(function (card) {
      card.style.display = 'none';
    });

    if (screenWidth >= 320 && screenWidth <= 767) {
      maxVisible = 1;
    } else if (screenWidth >= 1024) {
      maxVisible = maxVisibleSetting;
    } else {
      maxVisible = 2;
    }

    for (var i = currentIndex; i < currentIndex + maxVisible && i < cards.length; i++) {
      cards[i].style.display = 'flex';
    }

    var arrowWrapper = root.querySelector('.Pdp-Experts-Arrow-Wrapper');
    if (arrowWrapper) {
      arrowWrapper.style.display = cards.length <= maxVisible ? 'none' : 'flex';
    }
    toggleDisableClass(currentIndex);
  }

  window.addEventListener('resize', updateResponsiveExperts);
})();
